module.exports = __webpack_public_path__ + "img/logo_groot.f5290901.png";